import React, { useContext } from "react";
import styled from "styled-components";

import { WindowContext } from "../common/AppWrapper";

const Layout = styled.div`
  gap: 3rem;
  display: flex;
`;
const LayoutSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 30rem;
`;
const LayoutMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  flex: 1;
  min-width: 0;
`;

const ClassroomLayout = (props: {
  main: React.ReactNode;
  side: React.ReactNode;
}) => {
  const win = useContext(WindowContext);

  const isSmall = win.device === "phone";

  return (
    <Layout
      style={{
        flexDirection: isSmall ? "column" : "row",
      }}
    >
      <LayoutMain>{props.main}</LayoutMain>
      <LayoutSide
        style={{
          width: isSmall ? "100%" : "30rem",
        }}
      >
        {props.side}
      </LayoutSide>
    </Layout>
  );
};

export default ClassroomLayout;
